import { PageContext } from "vike/types";
import { createGtag } from "vue-gtag";

export const onCreateApp = (pageContext: PageContext) => {
  const { app } = pageContext;
  const gtag = createGtag({
    tagId: import.meta.env.PUBLIC_ENV__GOOGLE_ANALYTICS,
  });

  app?.use(gtag);
};
